import { State } from 'xstate';
import { ComponentsMachine } from './getComponentsUsedInBilling';

export type ComponentsState = State<ComponentsMachine['context']>;

export const getComponentsUpdatesAllowed = (machineState: ComponentsState) => {
  const productCatalogItems = machineState.context.items;
  return productCatalogItems.some((item) => item.component.updatesAllowed);
};
